<template>
    <div class="select_scene">
        <div class="select_menus">
            <SrcSelectButton
                class="src_btn_modal"
                :class="{opened}"
                :aspectRatioStyle="'calc(68 / 139 * 100%)'"
                @click.native="() => opened = !opened"
            >
                <label class="input_file">
                    <input type="file" accept="image/*" @change="uploadBackgroundImage($event)"/>
                </label>
                <!-- <UploadThenSetBgImage :active="opened" @uploadDone="() => setModal('')" /> -->
                <div class="btn_container">
                    <div class="src_btn_illust">
                        <svg xmlns="http://www.w3.org/2000/svg" width="60.935" height="48.489" viewBox="0 0 60.935 48.489">
                            <g id="illust_camera" transform="translate(-188.463 -356.244)">
                                <path class="s_color" id="パス_365" data-name="パス 365" d="M202.889,403.733h-7.354a6.068,6.068,0,0,1-6.068-6.067v-27.08a6.068,6.068,0,0,1,6.068-6.068h9.609l4.771-6.017a2.525,2.525,0,0,1,2.186-1.257H225.76a2.526,2.526,0,0,1,2.186,1.257l4.77,6.017h9.608a6.068,6.068,0,0,1,6.068,6.068v27.08a6.068,6.068,0,0,1-6.068,6.067H202.889Z" transform="translate(0 0)" fill="none" stroke="#2e2e2b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                <path class="s_color" id="パス_366" data-name="パス 366" d="M202.263,383.12a1.011,1.011,0,1,1-1.011-1.011A1.011,1.011,0,0,1,202.263,383.12Z" transform="translate(-5.529 -12.762)" fill="none" stroke="#2e2e2b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                <line class="s_color" id="線_40" data-name="線 40" x1="16.965" y1="0.096" transform="translate(189.469 376.043)" fill="none" stroke="#2e2e2b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                <line class="s_color" id="線_41" data-name="線 41" x1="16.886" y1="0.096" transform="translate(231.507 376.281)" fill="none" stroke="#2e2e2b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                <circle class="s_color" id="楕円形_46" data-name="楕円形 46" cx="14.344" cy="14.344" r="14.344" transform="translate(204.586 368.841)" fill="none" stroke="#2e2e2b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                <circle class="s_color" id="楕円形_47" data-name="楕円形 47" cx="10.178" cy="10.178" r="10.178" transform="translate(208.753 373.007)" fill="none" stroke="#2e2e2b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                <path class="s_color" id="パス_367" data-name="パス 367" d="M258.175,414.374a7.016,7.016,0,0,1-3.591,3.8" transform="translate(-33.422 -29.323)" fill="none" stroke="#2e2e2b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                            </g>
                        </svg>
                    </div>
                    アルバムから選ぶ
                </div>
            </SrcSelectButton>
            <dl class="menu_btns">
                <dt class="menu_btns__title">サンプルから選ぶ</dt>
                <dd class="menu_btns__container">
                    <button
                        v-for="{name, label} in presetSample"
                        @click="switchPreset(name)"
                        :key="name"
                        :class="{name, active: currentPreset === name}"
                        class="scene_btn"
                    ><p>{{ label }}</p></button>
                </dd>
            </dl>
        </div>
        <div class="view_area">
            <SelectPresetScene
                :dirname="currentPreset"
                :prefix="currentScenes.prefix"
                :samples="currentScenes.samples"
                :preset="selected_scene"
                @setBgImage="setBgImageByIndex"/>
        </div>
    </div>
</template>

<script>
    import { mapMutations , mapActions, mapState } from 'vuex'
    import SelectPresetScene from "./SelectPresetScene";
    import SrcSelectButton from "../parts/SrcSelectButton.vue";
    // import UploadThenSetBgImage from '../parts/UploadThenSetBgImage.vue';
    import {loadImage} from '../../assets/js/loadImageByPromise'
    import {compressImage, checkLocalStorageAvailable} from '../../assets/js/util'
    import CONST from '../../assets/js/const'

    const presetSample = [
        {
            name: 'living',
            label: 'リビング',
            prefix: 'living',
            samples: ['5-1', '5-2', '5-3', '5-4', '5-5','1','6', '7','2', '3', '4', ]
        },
        {
            name: 'bedroom',
            label: '寝室',
            prefix: 'bedroom',
            samples: ['8-1', '8-2', '8-3', '8-4', '8-5', '9', '10']
        },
        {
            name: 'kidroom',
            label: '子供部屋',
            prefix: 'kidroom',
            samples: ['11', '12'],
        },
        {
            name: 'workspace',
            label: 'ワークスペース',
            prefix: 'workspace',
            samples: ['13', '14'],
        },
        {
            name: 'japanese_room',
            label: '和室',
            prefix: 'jp',
            samples: ['15', '16', '17']
        },
        {
            name: 'kitchen',
            label: 'キッチン',
            prefix: 'kitchen',
            samples: ['18', '19', '20']
        },
        {
            name: 'sanitary',
            label: '洗面',
            prefix: 'sanitary',
            samples: ['21', '22']
        },
        {
            name: 'muji',
            label: '無地',
            prefix: 'muji',
            samples: ['1', '2']
        }
    ]

    export default {
        name: "SelectScene",
        components: {SelectPresetScene, SrcSelectButton },
        data: () => ({
            currentPreset: 'living',
            presetSample,
            opened: false
        }),
        mounted () {
            [this.currentPreset] = this.selected_scene !== ''
                ? this.selected_scene.split('/') || ['living']
                : ['living'];
            // console.log(this.currentPreset)
        },
        computed: {
            ...mapState('simulator', ['image_list', 'selected_scene']),
            currentScenes() {
                return this.presetSample.find(({name}) => this.currentPreset === name)
            }
        },
        methods: {
            ...mapMutations(["setModal"]),
            ...mapMutations('simulator', ["deleteTempItem", "setSelectedScene", "setSelectedScene"]),
            ...mapActions(["resetTimer"]),
            ...mapActions('simulator', ["commitTempItem", "resetItemList", "setSmapleSceneClipping"]),
            async uploadBackgroundImage(ev) {
                const [file] = ev.target.files;
                if ( !this.fileValidation(file) ) return alert('画像のアップロードに失敗しました。\njpeg形式の画像ファイルを選択してください。');

                this.setSelectedScene('');
                this.setBgImage(file)
            },
            async setBgImageByIndex(path) {
                const blob = await (await fetch(`assets/images/scenes/${path}.jpg`)).blob()
                const file = new File([blob], `${path}.jpg`)

                this.setSelectedScene(path);
                this.setBgImage(file)
            },
            fileValidation(file) {
                if (!file) return false;
                if (file.type !== 'image/jpeg') return false;

                return true;
            },
            async setBgImage(file) {
                this.$store.commit('setIsLoading', true);

                const url = URL.createObjectURL(file);

                const img = await loadImage(url);
                const compressed_base64_img = await compressImage(img, 1000000);

                this.$store.commit('setBackgroundImage', await loadImage(compressed_base64_img))
                if ( checkLocalStorageAvailable() ) localStorage.setItem(CONST.LOCAL_STORAGE_IMG_KEY, compressed_base64_img);
                // すでに製品を選択済みであるか
                const currentMetas = this.image_list.filter(({meta}) => meta?.length > 0);
                if (currentMetas.length === 0) {
                    this.resetItemList();
                }
                this.resetTimer();
                this.$emit('closeModal')
                this.$store.commit('setIsLoading', false);
            },
            switchPreset(presetName) {
                this.currentPreset = presetName;
                document.querySelectorAll('.scene_btn').forEach(el => el.classList.remove('active'))
                document.querySelectorAll(`.scene_btn.${presetName}`).forEach(el => el.classList.add('active'))
            }
        }
    }
</script>

<style lang="scss">
    // @import "../../assets/css/define";
    input {
        -webkit-appearance: none;
        border-radius: 0;
    }
    .select_scene {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        height: 100%;
        .select_menus {
            display: flex;
            flex-wrap: wrap;
            flex-flow: column;
            justify-content: space-between;
            width: 45%;
            height: 100%;
            button{
                width: calc(50% - 7.5px);
                height: calc(25% - 5px);
                background-color: rgba(255,255,255,0.5);
                border: 1px solid #000;
                text-align: center;
                padding: 5px 10px;
                border-radius: 3px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: clamp(10px, 1.2vw, 20px);
                transition: 0.3s;
                p{
                    font-size: clamp(10px, 1.2vw, 20px);
                    margin: 0;
                }
                svg{
                    width: calc(26 / 139 * 100%);
                    height: auto;
                }
            }
            button:hover,
            button.active{
                background-color: #000;
                color: #fff;
                svg #illust_camera .s_color{
                    stroke: #fff;
                }
            }
            .album{
                width: 100%;
                height: calc(35% - 10px);
                outline: none;
            img{
                display: block;
                margin: 0 auto 10px auto;
            }
            }
            .menu_btns {
                height: 65%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                margin: 0;
                .menu_btns__title {
                    width: 100%;
                    height: 10%;
                    font-size: clamp(12px, 1.2vw, 20px);
                    line-height: 1;
                    &::before {
                        display: inline-block;
                        content: '';
                        width: 0;
                        height: 0;
                        border-left: 8px solid transparent;
                        border-right: 8px solid transparent;
                        border-top: 10px solid black;
                        margin-right: 3px;
                    }
                }
                .menu_btns__container {
                    margin-left: 0;
                    height: 90%;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    width: 100%;
                    > button {
                        word-break: keep-all;
                        line-break: strict;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        &.workspace {
                            padding-top: 0.2px;
                            padding-bottom: 0.2px;
                            line-height: 1;
                        }
                    }
                }
            }
        }
        .view_area{
            width: calc(55% - 20px);
            height: 100%;
            overflow: auto;
        }
        .input_file {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            cursor: pointer;
            > input {
                display: none;
                -webkit-appearance: none;
                border-radius: 0;
                outline: none;
                border: none ;
            }
        }
    }
    @media (max-width: 739px) {
        .select_scene {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            height: 100%;
            .select_menus {
                display: flex;
                flex-wrap: wrap;
                flex-flow: column;
                justify-content: space-between;
                width: 40%;
                height: 100%;
                button{
                    width: calc(50% - 2.5px);
                    height: calc(25% - 5px);
                    font-size: 10px;
                    padding: 5px;
                    display: flex;
                }
                .album{
                    width: 100%;
                    height: calc(35% - 10px);
                    img{
                        display: block;
                        margin: 0 auto 10px auto;
                    }
                }
                .menu_btns {
                    height: 65%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: wrap;
                    margin: 0;
                    .menu_btns__title {
                        height: 20px;
                        font-size: 10px;
                        &::before {
                            display: inline-block;
                            content: '';
                            width: 0;
                            height: 0;
                            border-left: 6px solid transparent;
                            border-right: 6px solid transparent;
                            border-top: 6px solid black;
                            margin-right: 3px;
                        }
                    }
                    .menu_btns__container {
                        margin-left: 0;
                        height: calc(100% - 20px);
                        > button {
                            word-break: keep-all;
                            line-break: strict;
                            word-wrap: break-word;
                            overflow-wrap: break-word;
                            &.workspace {
                                padding-top: 0.2px;
                                padding-bottom: 0.2px;
                                line-height: 1;
                            }
                        }
                    }
                }
            }
            .view_area{
                width: calc(60% - 10px);
            }
        }
    }
</style>
<style lang="scss">
    .src_btn_modal {
        width: 100% !important;
        &.opened {
            outline: none;
            .btn__wrapper{
            background-color: #fff;
            color: #000;
            label{
                cursor: pointer;
            }
            #illust_camera .s_color,
            #illust_room .s_color{
                stroke: #000;
            }
            #illust_room .s_color2{
                fill: #000;
            }
            #line{
                stroke: #000 !important;
            }

            }
        }
    .btn__wrapper {
        padding:
            calc(16 / 252 * 100%)
            calc(8 / 252 * 100%);
    }
    .btn_container {
        box-sizing: content-box;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        .src_btn_illust {
            width: 100%;
                .illust__camera {
                    width: calc(26 / 139 * 100%);
                    height: auto;
                }
            }
        }
    }
</style>
